import { useCallback, useRef } from "react";

// eslint-disable-next-line import/no-unused-modules
export const useDebounce = <F extends (...args: any) => any>(func: F, delay: number): F => {
    // @ts-ignore
    const timeout = useRef<NodeJS.Timeout>();

    return useCallback(
        // @ts-expect-error args
        (...args) => {
            const later = () => {
                clearTimeout(timeout.current);
                func(...args);
            };

            clearTimeout(timeout.current);
            timeout.current = setTimeout(later, delay);
        },
        [func, delay],
    );
};